import { connect } from 'react-redux';
import { TourTypeSelector } from './TourTypeSelector';
import { IAppState } from 'types/appState.type';

const mapStateToProps = (state: IAppState): IAppState => {
	return { ...state };
};

export default connect(mapStateToProps, null)(TourTypeSelector);
